import * as jsxRuntime from "/home/byczynm1/actions-runner-fashion-infra/_work/_temp/yourmodel-frontend-context/vite-frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment